import React from "react";
import { Modal } from "react-bootstrap";

interface MeterModalsProps {
  deleteCandidate: number | null;
  setDeleteCandidate: (id: number | null) => void;
  onConfirmDelete: (id: number) => void;
  showPreview: boolean;
  setShowPreview: (show: boolean) => void;
  iframeUrl: string;
}

const MeterModals: React.FC<MeterModalsProps> = ({
  deleteCandidate,
  setDeleteCandidate,
  onConfirmDelete,
  showPreview,
  setShowPreview,
  iframeUrl,
}) => {
  return (
    <>
      {/* Delete Confirmation */}
      <Modal
        show={deleteCandidate !== null}
        onHide={() => {
          setDeleteCandidate(null);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Meter</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure? This cannot be undone.</Modal.Body>
        <Modal.Footer>
          <button
            className="sales-doc-btn-secondary"
            onClick={() => {
              setDeleteCandidate(null);
            }}
          >
            Cancel
          </button>
          <button
            className="sales-doc-btn-danger"
            onClick={() => {
              if (deleteCandidate !== null) onConfirmDelete(deleteCandidate);
            }}
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>

      {/* HTML Preview */}
      <Modal
        show={showPreview}
        onHide={() => {
          setShowPreview(false);
        }}
        size="xl"
      >
        <iframe
          src={iframeUrl}
          title="Document Preview"
          style={{ width: "100%", height: "90vh", border: "none" }}
        />
      </Modal>
    </>
  );
};

export default MeterModals;
